var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuyTests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.5 283.5",
    style: {
      enableBackground: "new 0 0 283.5 283.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#325CA7;}\n\t.st1{fill:#B9CFC0;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#29384F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 141.6,
    cy: 141.4,
    r: 109.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M176.9,160.1h-72.4l-6.8-48.9h83.9c4.1,0,7.3,4,6.7,8.4l-4.7,34.3C183.1,157.5,180.2,160.1,176.9,160.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M191.7,182.8h-84.1c-2.4,0-4.4-1.8-4.8-4.1l-9.3-63.3L64.5,97.8c-2.3-1.4-3-4.3-1.6-6.6c1.4-2.3,4.3-3,6.6-1.6 l31.1,18.8c1.2,0.7,2.1,2,2.3,3.4l9,61.4h79.9c2.7,0,4.8,2.2,4.8,4.8C196.6,180.6,194.4,182.8,191.7,182.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 113.3,
    cy: 193.7,
    rx: 7.7,
    ry: 7.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.3,186c4.3,0,7.7,3.5,7.7,7.7c0,4.3-3.5,7.7-7.7,7.7c-4.3,0-7.7-3.5-7.7-7.7 C105.6,189.4,109.1,186,113.3,186 M113.3,180.9c-7.1,0-12.8,5.8-12.8,12.8c0,7.1,5.7,12.8,12.8,12.8c7.1,0,12.8-5.8,12.8-12.8 C126.2,186.6,120.4,180.9,113.3,180.9L113.3,180.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 180.3,
    cy: 193.7,
    rx: 7.7,
    ry: 7.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M180.3,186c4.3,0,7.7,3.5,7.7,7.7c0,4.3-3.5,7.7-7.7,7.7c-4.3,0-7.7-3.5-7.7-7.7 C172.6,189.4,176.1,186,180.3,186 M180.3,180.9c-7.1,0-12.8,5.8-12.8,12.8c0,7.1,5.7,12.8,12.8,12.8c7.1,0,12.8-5.8,12.8-12.8 C193.2,186.6,187.4,180.9,180.3,180.9L180.3,180.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M182.8,164.9H105c-2.7,0-4.8-2.2-4.8-4.8c0-2.7,2.2-4.8,4.8-4.8h73.8l7.8-40.2c0.5-2.6,3-4.3,5.6-3.8 c2.6,0.5,4.3,3,3.8,5.6l-8.5,44.1C187.1,163.3,185.1,164.9,182.8,164.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyTests);
export default __webpack_public_path__ + "static/media/Buy_tests.0134681558ed8fb3809b37c90d0e00b4.svg";
export { ForwardRef as ReactComponent };